import { FC, ReactNode } from 'react'
import { SegmentAvatar, SegmentAvatarType } from './Avatar'
import { SegmentCard, SegmentCardType } from './Card'
import { CardListType, SegmentCardList } from './CardList'
import { SegmentOption, SegmentOptionType } from './Option'

const Segment: FC &
  SegmentAvatarType &
  SegmentCardType &
  CardListType &
  SegmentOptionType = (): ReactNode => <></>

Segment.Avatar = SegmentAvatar
Segment.Card = SegmentCard
Segment.CardList = SegmentCardList
Segment.Option = SegmentOption

export default Segment
